export const seoData = {
  review: {
    seoTitle:
      '<brand-name> <model-name> User Reviews | Pros and Cons by Expert <current-year>',
    seoDescription:
      'Read <brand-name> <model-name> user review, experts pros and cons. Discover its features, performance, and more. Honest insights for your car deal.',
  },
  price: {
    seoTitle:
      '<brand-name> <model-name> Price in <place> - On-Road & Ex-Showroom Price <current-month> <current-year>',
    seoDescription:
      '<brand-name> <model-name> Price in <place> starts from <base-variant-price>. Check On-Road, Ex-Showroom Price & EMI offers of <model-name> in <place>',
  },
  images: {
    seoTitle: ' <brand-name> <model-name> Images - Interior & Exterior Photo Gallery',
    seoDescription:
      'Explore <brand-name> <model-name> <image-count> high quality exterior and interior images. Checkout <model-name> front, side, rear, top, and other views.',
  },
  mileage: {
    seoTitle:
      '<brand-name> <model-name> Mileage/ Average for <fuel-type>',
    seoDescription:
      "Experience the fuel efficiency of <brand-name> <model-name> with the best mileage of <base-model-mileage>. Discover car's average and performance for the next journey.",
  },
  colour: {
    seoTitle:
      '<brand-name> <model-name> Colours - Check <no-of-colors> Colors in India <current-year>',
    seoDescription:
      'Check out different color shades of <brand-name> <model-name> available in <no-of-colors> options - <all-color-name>',
  },
  variants: {
    seoTitle:
      '<brand-name> <model-name> Variants - Check Base Model to Top Model Details in India',
    seoDescription:
      'Discover <brand-name> <model-name> all variants starting for <base-variant-price> to <top-variant-price>. Explore features, performance, and multiple price options. Book a Test Drive for <model-name> Today!',
  },
  specification: {
    seoTitle:
      '<brand-name> <model-name> Specifications - Features, Engine CC, Configurations',
    seoDescription:
      'Explore <brand-name> <model-name> engine options, performance, and notable features that makes <brand-name> <model-name> a standout choice in its segment. Discover more for Detailed specs',
  },
};
